import { customAlphabet } from "nanoid";

const ALPHABETS =
	"0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";

export const getNanoId = customAlphabet(ALPHABETS, 8);
